if (!customElements.get('kit-view-all')) {
  class KitViewAll extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        expanded: 'expanded',
        collapsed: 'kit-component--collapsed',
        list: 'js-pdp-kit-products-list',
        components: 'js-pdp-kit-components',
        btn: 'js-kit-view-all-btn',
      };
    }

    get elements() {
      const list = this.closest(`.${this.classes.components}`).querySelector(`.${this.classes.list}`);
      return {
        btn: this.querySelector(`.${this.classes.btn}`),
        list,
        collapsed: list ? list.querySelectorAll(`.${this.classes.collapsed}`) : [],
      };
    }

    connectedCallback() {
      const { btn, collapsed } = this.elements;
      if (!btn) return;

      collapsed.forEach((el) => (el.style.display = 'none'));
      btn.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      const { btn, collapsed } = this.elements;
      const expanded = btn.getAttribute('data-expanded') === 'true';
      if (expanded) {
        collapsed.forEach((el) => (el.style.display = 'none'));
        btn.setAttribute('data-expanded', 'false');
        btn.textContent = btn.dataset.viewAllText;
      } else {
        collapsed.forEach((el) => (el.style.display = ''));
        btn.setAttribute('data-expanded', 'true');
        btn.textContent = btn.dataset.showLessText;
      }
    }
  }

  customElements.define('kit-view-all', KitViewAll);
}
